module.exports = __webpack_public_path__ + "img/dcim03.287f1ad6.jpg";